module.exports = __webpack_public_path__ + "static/img/tarija.6e5b97d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/departamentales/tarija.png
// module id = UdST
// module chunks = 1